export enum EMFALoginSteps {
  MULTI_FACTOR_LOGIN,
  DISCONNECT_DEVICES,
  DISCONNECT_DEVICES_FEEDBACK,
  TALK_TO_WARREN
}
